import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateCreateUser = {
  createUser: { data: null, loading: false, error: null },
};

export const createUser = createAsyncThunk('user/createUser', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/users/`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCreateUser = {
  [createUser.pending]: (state) => {
    state.createUser.loading = true;
    state.createUser.error = null;
  },
  [createUser.fulfilled]: (state, action) => {
    state.createUser.loading = false;
    state.createUser.data = action.payload;
    state.createUser.error = null;
  },
  [createUser.rejected]: (state, action) => {
    state.createUser.loading = false;
    state.createUser.error = action.payload;
  },
};
